import React from "react";
import {
  AppBar,
  Box,
  IconButton,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  Drawer,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate, useLocation } from "react-router-dom";

const drawerWidth = 240;

const pages = [
  { label: "UTA Highlight", path: "/uta_faculty_awards" },
  { label: "Awards", path: "/awards" },
  { label: "Awardees", path: "/awardees" },
  { label: "Organization", path: "/societies" },
  { label: "Correlated Awards", path: "/correlated_awards" },
];

const topLinks = [
  { label: "ABOUT", path: "/about" },
  { label: "TIPS", path: "/tips" },
];

export default function SideBarComponent() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = pages.findIndex(
    (p) =>
      location.pathname === p.path || location.pathname.startsWith(p.path + "/")
  );

  const handleTabChange = (_, newValue) => {
    navigate(pages[newValue].path);
  };

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  return (
    <>
      <AppBar
        position="fixed"
        elevation={1}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
        }}
      >
        <Toolbar
          sx={{
            flexDirection: "column",
            alignItems: "center",
            py: 2,
            position: "relative",
          }}
        >
          {isSmallScreen && (
            <IconButton
              color="inherit"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ alignSelf: "flex-start", mb: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {!isSmallScreen && (
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 24,
                display: "flex",
                gap: 3,
              }}
            >
              {topLinks.map((link) => (
                <Typography
                  key={link.label}
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(link.path)}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          )}

          <Typography variant="h5" fontWeight="bold" align="center">
            A Database of International, National and Regional Scholar Awards
          </Typography>
          <Typography variant="body2" align="center" sx={{ mt: 0.5 }}>
            Academic Scholars brings together Awards from STEM, the Liberal
            Arts, Medicine, and Business
          </Typography>
        </Toolbar>

        {!isSmallScreen && (
          <Tabs
            value={currentTab !== -1 ? currentTab : false}
            onChange={handleTabChange}
            sx={{
              backgroundColor: "#1565c0",
              color: "#fff",
              "& .MuiTab-root": {
                fontWeight: "bold",
                fontSize: "0.95rem",
                textTransform: "none",
                color: "#fff",
                minWidth: 130,
                "&.Mui-selected": {
                  color: "#fff",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#fff",
                height: 3,
              },
            }}
          >
            {pages.map((page) => (
              <Tab key={page.label} label={page.label} />
            ))}
          </Tabs>
        )}
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant={isSmallScreen ? "temporary" : "persistent"}
        anchor="left"
        open={open}
        onClose={handleDrawerClose}
      >
        <Toolbar sx={{ justifyContent: "flex-end" }}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </Toolbar>
        <Divider />
        <Box sx={{ px: 2, mt: 2 }}>
          {[...pages, ...topLinks].map((page) => (
            <Box
              key={page.label}
              sx={{
                mb: 2,
                fontWeight: 500,
                cursor: "pointer",
                color:
                  location.pathname === page.path
                    ? "primary.main"
                    : "text.primary",
              }}
              onClick={() => {
                navigate(page.path);
                handleDrawerClose();
              }}
            >
              {page.label}
            </Box>
          ))}
        </Box>
      </Drawer>
    </>
  );
}
